import { styled } from '@linaria/react'
import { FIXED_INDENTS } from 'vars/index'

export const PageTitleSC = styled.div<{
  paddings?: string[]
  noTabs?: boolean
}>`
  padding: ${({ paddings }) =>
    paddings && paddings.length > 0
      ? paddings.map((item) => `var(${item})`)?.join(' ')
      : 0};

  padding-bottom: ${({ noTabs, paddings }) =>
    noTabs
      ? `var(${FIXED_INDENTS.INDENT_30})`
      : paddings && paddings.length > 2
        ? `var(${paddings[2]})`
        : 'initial'};
`
